import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class CustomUserService {

  constructor(private httpClient: HttpClient) {
  }

  resetPassword(userUniqId: string) {
    return this.httpClient.put(environment.baseUrlWs + '/api/users/' + userUniqId + '/reset-password-request', null);
  }

  resetApiKey(userUniqId: string) {
    return this.httpClient.put(environment.baseUrlWs + '/api/users/' + userUniqId + '/reset-apikey', null);
  }

  reset2Fa(userUniqId: string) {
    return this.httpClient.put(environment.baseUrlWs + '/api/users/' + userUniqId + '/reset-2fa', null);
  }

  resendInvitation(userUniqId: string) {
    return this.httpClient.put(environment.baseUrlWs + '/api/users/' + userUniqId + '/resend-invitation', null);
  }

  invalidateUser(uniqid: string) {
    return this.httpClient.put(environment.baseUrlWs + '/api/users/' + uniqid + '/invalidate', null);
  }

  getClientIp(): Observable<string> {
    return this.httpClient.get<string>(environment.baseUrlWs + '/api/user-ip');
  }

  isGenericDomain(domain: any) {
    return this.httpClient.get<string>(environment.baseUrlWs + '/api/user/domain?domain=' + domain);
  }

  validateUser(uniqid: string) {
    return this.httpClient.put(environment.baseUrlWs + '/api/users/' + uniqid + '/validate', null);
  }

  confirmDomain(id: number) {
    return this.httpClient.put(environment.baseUrlWs + '/api/users/' + id + '/confirm-domain', null);
  }

  verifyUserPassword(passwordForm) {
    return this.httpClient.post(environment.baseUrlWs + '/user/admin/verify-user-password', passwordForm);
  }

  getEmailDomain(email: string) {
    let emailSuffix = email.substring(email.indexOf('@') + 1);
    if ((emailSuffix.split('.')).length > 2) {
      const emailDomains = emailSuffix.split('.');
      const emailDomainsLength = emailDomains.length;
      emailSuffix = emailDomains[emailDomainsLength - 2] + '.' + emailDomains[emailDomainsLength - 1];
    }
    return emailSuffix;
  }

  confirmAuthCode(code: any, dontAskAgainChecked: boolean) {
    return this.httpClient.post<any>(environment.baseUrlWs + '/api/confirm-mfa-code', {
      'code': code,
      'dontAskAgain': dontAskAgainChecked
    }, {withCredentials: true});
  }

  resendMfaCode() {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/resend-mfa-code');
  }

  downloadUserAuthorization(userId): Observable<any> {
    return this.httpClient.get(environment.baseUrlWs + '/api/download-authorization?userId=' + userId);
  }

  downloadAllAuthorizations(): Observable<any> {
    return this.httpClient.get(environment.baseUrlWs + '/api/download-all-authorizations');
  }

  activateDistributionList(userId): Observable<any> {
    return this.httpClient.get(environment.baseUrlWs + '/api/activate-distribution-list/' + userId);
  }

  deactivateDistributionList(userId): Observable<any> {
    return this.httpClient.get(environment.baseUrlWs + '/api/deactivate-distribution-list/' + userId);
  }

  isLastUserForAtLeastOneRole(userId: string) {
    return this.httpClient.get(environment.baseUrlWs + '/api/last-role-user/' + userId);
  }
}
